import { useMemo } from 'react'

import type { ReturnUseCalendarData, ExtendedProps } from './useCalendarData'

export const useFilterCalendar = (
  calendarData: ReturnUseCalendarData,
  {
    viewType,
    tagFilter,
  }: {
    viewType?: 'sessions' | 'subEvents'
    tagFilter?: string | null
  }
) => {
  const { sessions, events } = calendarData
  const _selectedEvents = viewType === 'sessions' ? sessions : events

  const filteredEvents = useMemo(() => {
    if (!tagFilter) return _selectedEvents

    return _selectedEvents?.filter(event => {
      const extendedProps = event.extendedProps as ExtendedProps
      return (
        extendedProps.type?.some(tag => tag === tagFilter) ??
        extendedProps.sessions?.some(session => session.tags?.some(tag => tag === tagFilter))
      )
    })
  }, [_selectedEvents, tagFilter])

  return filteredEvents
}
